<span class="text-nowrap">
  @if (icon()) {
    <lucide-icon [img]="icon()"></lucide-icon>
  }
  @if (text()) {
    <span class="ms-1">{{ text() }}</span>
  }
</span>
